var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title !== undefined)?_c('v-card-title',{staticClass:"mx-n4"},[_vm._v(_vm._s(_vm.title)+" "),_c('v-spacer')],1):_vm._e(),(_vm.isLoading)?_c('v-row',{staticStyle:{"height":"200px"},attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"size":75,"color":"primary","indeterminate":""}})],1):_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }